import React, { useState } from 'react';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import ciisGlobalLogo from '../ciis-logo.jpg';
import brochure from '../brochure.pdf';

const HomePage = () => {
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    fullname: '',
    mobile: '',
    email: ''
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(
        'https://sdvtii.in/api-rstilrac/enquiryform',
        formData
      );

      if (response.data.ok) {
        toast.success('Thank you! Enquiry submitted successfully 🎉', {
          position: "top-center",
          autoClose: 3500,
        });

        // Trigger brochure download
        const link = document.createElement('a');
        link.href = brochure;
        link.download = 'CIIS_Brochure.pdf';
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);

        setFormData({ fullname: '', mobile: '', email: '' });
      } else {
        toast.warn('Something went wrong. Please try again.');
      }
    } catch (error) {
      toast.error('Server error. Please try again later.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div
        className="min-vh-100 d-flex align-items-center"
        style={{
          background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        }}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-12 col-md-8 col-lg-5">

              {/* Card with subtle glass effect + shadow */}
              <div
                className="card border-0 shadow-lg overflow-hidden"
                style={{
                  borderRadius: '1.5rem',
                  background: 'rgba(255, 255, 255, 0.93)',
                  backdropFilter: 'blur(10px)',
                }}
              >
                {/* Header / Logo */}
                <div className="card-header bg-transparent border-0 pt-5 pb-1 text-center">
                  <img
                    src={ciisGlobalLogo}
                    alt="CIIS Global Logo"
                    className="img-fluid"
                    style={{ maxHeight: '90px', width: 'auto' }}
                  />
                  <h4 className="mt-3 mb-1 fw-bold text-primary">
                    Get In Touch
                  </h4>
                  <p className="text-muted small mb-0">
                    Fill the form & get our brochure instantly
                  </p>
                </div>

                {/* Form */}
                <div className="card-body px-4 px-md-5 pb-5">
                  <form onSubmit={handleSubmit} noValidate>
                    {/* Full Name */}
                    <div className="form-floating mb-4">
                      <input
                        type="text"
                        className="form-control form-control-lg rounded-4"
                        id="fullname"
                        name="fullname"
                        placeholder="Full Name"
                        value={formData.fullname}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="fullname">Full Name</label>
                    </div>

                    {/* Mobile */}
                    <div className="form-floating mb-4">
                      <input
                        type="tel"
                        className="form-control form-control-lg rounded-4"
                        id="mobile"
                        name="mobile"
                        placeholder="Mobile Number"
                        value={formData.mobile}
                        onChange={handleChange}
                        required
                        pattern="[0-9]{10}"
                        title="Please enter a valid 10-digit mobile number"
                      />
                      <label htmlFor="mobile">Mobile Number</label>
                    </div>

                    {/* Email */}
                    <div className="form-floating mb-5">
                      <input
                        type="email"
                        className="form-control form-control-lg rounded-4"
                        id="email"
                        name="email"
                        placeholder="name@example.com"
                        value={formData.email}
                        onChange={handleChange}
                        required
                      />
                      <label htmlFor="email">Email Address</label>
                    </div>

                    {/* Submit Button */}
                    <button
                      type="submit"
                      className="btn btn-primary btn-lg w-100 rounded-4 fw-bold shadow-sm"
                      disabled={loading}
                      style={{
                        padding: '0.85rem',
                        fontSize: '1.1rem',
                        background: 'linear-gradient(90deg, #667eea, #764ba2)',
                        border: 'none',
                      }}
                    >
                      {loading ? (
                        <>
                          <span
                            className="spinner-border spinner-border-sm me-2"
                            role="status"
                            aria-hidden="true"
                          ></span>
                          Submitting...
                        </>
                      ) : (
                        'Submit'
                      )}
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ToastContainer
        position="top-center"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="colored"
      />
    </>
  );
};

export default HomePage;